import config from './config';

__webpack_public_path__ = config.basePath;

// Initialize WebSocket retry handler early (for HMR)
import('./utils/ws-retry-handler');

import('bootstrap');
